<template>
  <div>
    <!--        <div>-->
    <!--            <img src="https://freakchicken.gitee.io/images/kafkaui/wechatpay.jpg">-->

    <!--        </div>-->
    <h2>开源地址</h2>
    <div>
      <el-link type="primary" href="https://gitee.com/freakchicken/kafka-ui-lite" target="_blank">gitee</el-link>
    </div>
    <div>
      <el-link type="primary" href="https://github.com/freakchick/kafkaUI-lite" target="_blank">github</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "donate"
}
</script>

<style scoped lang="scss">
div {
  /*margin: 0 auto;*/
  img {
    width: 300px;
  }

  text-align: center;
}

</style>
